import { useGetCompanyDataQuery, useGetFranchiseDataQuery } from '../../../../store/api-slices';
import LoadingPage from '../../../../components-library/loading/LoadingPage';
import { useDefaultSlug } from '../../common/selectors/selectors';
import { FC, PropsWithChildren } from 'react';

const SlugGuard: FC<PropsWithChildren> = ({ children }) => {
  const { slug, hasCompany } = useDefaultSlug();
  const { isFetching } = useGetFranchiseDataQuery(false, { skip: !!slug });
  const { isFetching: isCompanyFetching } = useGetCompanyDataQuery({
    slug,
    hideLoading: true,
  });

  if (!hasCompany) {
    return <LoadingPage />;
  }

  return (
    <>
      {children}
      {isFetching || (isCompanyFetching && <LoadingPage />)}
    </>
  );
};

export default SlugGuard;
